module.exports = __webpack_public_path__ + "img/wechat.70ded3a2.png";